<template>
	<div>
		<!-- <b-card-header header-tag="header" class="p-0 mt-2 mb-0" role="tab">
			<base-button block size="sm" type="warning" class="border-non-radius text-white text-left">
				Files/Data
			</base-button>
		</b-card-header> -->
		<b-card-body class="text-center pl-0 pr-0 pt-2 pb-2">
			<b-row class="justify-content-end">
				<!-- <b-col cols="10"></b-col> -->
				<!-- <b-col class="float-right"> -->
				<b-button
          v-if="!isLoading && !errorStatus"
          data-cy="ota-add-file-btn" 
          size="sm" 
          variant="success" 
          class="mt-2 mb-2 mr-4" 
          title="Add File" 
          @click="addFile = true"
          :disabled="addFile"
        >
					<i class="fas fa-plus"></i> New
				</b-button>
				<!-- </b-col> -->
			</b-row>
			<div class="responsive-table">
				<table class="table table-striped-dark" id="myTable">
					<thead>
						<th scope="col-4">
							<span class="text-white">Display Name</span>
						</th>
						<th scope="col-2"><span class="text-white">EF</span></th>
						<th scope="col-2"><span class="text-white">Default</span></th>
						<th scope="col-2"><span class="text-white">Data</span></th>
						<th>
              <base-button
                type="warning"
                size="sm"
                class="float-right"
                v-on:click="updateFiles"
                title="Refresh Results"
                v-b-tooltip.hover
              >
                <i class="fa fa-recycle"></i>
              </base-button>

            </th>
					</thead>
          <tbody v-if="isLoading">
            <tr>
              <td colspan="5" class="text-center">
                <!-- <b-spinner class="align-middle"></b-spinner> -->
                Please wait for the carrier file audit...
                <br>
                <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
              </td>
            </tr>
          </tbody>
          <tbody v-if="errorStatus && !isLoading">
            <tr>
              <td colspan="5" class="text-center">
                <b-icon class="mt-2" icon="exclamation-triangle-fill" font-scale="4"></b-icon>
                <br>
                <p class="mt-2 font-md font-400">
                  Error loading {{ carrier.display_name }} files
                </p>
              </td>
            </tr>
          </tbody>
					<tbody v-if="!isLoading && !errorStatus">
						<tr
							class="text-black"
							v-for="(val, fileIndex) in files"
							:key="fileIndex"
							:class="val.disabled > 0 ? 'trDisabled' : ''"
						>
							<td class="pl-0 pr-0">
								<b-form-input
									size="sm"
									required
									v-model="val.display_name"
									placeholder="Display Name"
									:state="fileNameState(val.display_name, fileIndex)"
									:disabled="val.disabled > 0"
								>
								</b-form-input>
							</td>
							<td>
								<b-form-select
									v-if="!val.efDisabled"
									size="sm"
									v-model="val.type"
									:options="efOptions"
									placeholder="EF"
									class="text-uppercase"
									:state="efState(val.type)"
									@change="handleEfChange(val)"
								></b-form-select>
								<b-input
									v-else
									v-model="val.type"
									size="sm"
									:disabled="val.efDisabled"
									style="minwidth: 200px"
									class="text-uppercase"
								></b-input>
							</td>
							<td>
								<b-form-checkbox
                  data-cy="default-checkbox"
									size="sm"
									v-model="val.default"
									:disabled="val.disabled > 0"
								></b-form-checkbox>
							</td>
							<td>

								<div class="d-flex justify-content-around">
									<b-input
										v-if="val.type && fileTypes[val.type].data"
										size="sm"
										:id="'newFilesOne' + fileIndex"
										:name="'newFilesOne' + fileIndex"
										style="minwidth: 200px"
										v-model="val.data"
										:disabled="val.disabled > 0"
									></b-input>

									<div v-else class="d-flex w-100 justify-content-between">
										<b-input-group v-bind="val" v-if="updateFile.includes(fileIndex)">
											<input
												size="sm"
												:id="fileIndex"
												:name="fileIndex"
												class="w-0 h-0"
												type="file"
												@change="e => getFile(e, val)"
											/>
											<b-form-invalid-feedback :state="validateFile(val)">
												Please select a file
											</b-form-invalid-feedback>
										</b-input-group>
                    <b-button
                      v-if="!updateFile.includes(fileIndex)"
                      variant="primary"
                      size="sm"
                      :disabled="val.disabled > 0"
                      @click="setRowEdit(val, fileIndex)"
                    >
                      Replace File
                    </b-button>
                    <div class="d-flex justify-content-end">
                      <b-button
                        class="float-right"
                        v-if="fileErrors.includes(fileIndex)"
                        variant="danger"
                        size="sm"
                        @click="setRowEdit(val, fileIndex)"
                      >
                      <i class="fas fa-exclamation-triangle"></i>
                      </b-button>
                      <b-form-invalid-feedback :state="!fileErrors.includes(fileIndex)">
                        There is a problem with this file <br> Please upload a new file
                      </b-form-invalid-feedback>
                    </div>
									</div>

									<b-button-group
										v-if="
											val.display_name != val.previous.display_name ||
											val.data != val.previous.data ||
											val.default != val.previous.default
										"
										class="ml-2"
									>
										<b-button
											size="sm"
											variant="primary"
											@click="saveUpdatedFile(carrier, val, fileIndex)"
										>
											Save
										</b-button>
										<b-button
											size="sm"
											variant="danger"
											@click="cancelFileChange(carrier, val, fileIndex)"
										>
											Cancel
										</b-button>
									</b-button-group>
								</div>
							</td>
							<td class="text-md-right">
								<b-button
									class="vertical-dot-button"
									variant="primary"
									:id="`${carrier.name}-${val.name}-${fileIndex}-popover`"
								>
									<b-icon icon="three-dots-vertical" class="font-16"></b-icon>
								</b-button>
								<b-popover
									:target="`${carrier.name}-${val.name}-${fileIndex}-popover`"
									triggers="click blur"
								>
									<b-row>
										<base-button
											v-if="!fileTypes[val.type].data"
											type="link"
											v-on:click="
												getInfo_API({carrier: carrier.name, name: val.name, type: val.type})
											"
										>
											Info
										</base-button>
									</b-row>
									<b-row>
										<base-button
											v-if="!fileTypes[val.type].data"
											type="link"
											:title="val.disabled > 0 ? 'Enable file to download' : ''"
											v-on:click="
												downloadFile_API({
													carrier: carrier.name,
													name: val.name,
													type: val.type,
												})
											"
											:disabled="val.disabled > 0"
										>
											Download
										</base-button>
									</b-row>
									<b-row>
										<base-button
											v-if="val.disabled === 0"
											type="link"
											@click="
												showDisableFileModal({
													carrier: carrier.name,
													name: val.name,
													type: val.type,
													disable: 1,
												})
											"
										>
											Disable
										</base-button>
									</b-row>
									<b-row>
										<base-button
											v-if="val.disabled === 1"
											type="link"
											@click="
												showDisableFileModal({
													carrier: carrier.name,
													name: val.name,
													type: val.type,
													disable: 0,
												})
											"
										>
											Enable
										</base-button>
									</b-row>
									<b-row>
										<base-button v-if="isPortalAdmin" type="link" @click="deleteFile(val)">
											Delete
										</base-button>
									</b-row>
								</b-popover>
							</td>
						</tr>

						<!-- New File Fields -->
						<tr v-if="addFile">
							<td class="pl-0 pr-0">
								<b-form-input
									size="sm"
									required
									v-model="newFile.display_name"
									placeholder="Display Name"
									:state="fileNameState(newFile.display_name)"
								>
								</b-form-input>
							</td>
							<td>
								<b-form-select
									v-if="!newFile.efDisabled"
									size="sm"
									v-model="newFile.type"
									:options="efOptions"
									placeholder="EF"
									class="text-uppercase"
									:state="efState(newFile.type)"
									@change="handleEfChange(newFile)"
								></b-form-select>
								<b-input
									v-else
									v-model="newFile.type"
									size="sm"
									:disabled="newFile.efDisabled"
									style="minwidth: 200px"
									class="text-uppercase"
								></b-input>
							</td>
							<td>
								<b-form-checkbox size="sm" v-model="newFile.default"></b-form-checkbox>
							</td>
							<td>
								<b-input
									v-if="newFile.type && fileTypes[newFile.type].data"
									size="sm"
									:id="'newFile'"
									:name="'newFile'"
									class="w-0 h-0"
									:state="dataState"
									v-model="newFile.data"
									:placeholder="fileTypes[newFile.type].placeholder"
								></b-input>
								<b-input-group v-else>
									<input
										size="sm"
										:id="'newFile'"
										:name="'newFile'"
										class="w-0 h-0"
										type="file"
										@change="e => getFile(e, newFile)"
									/>
									<b-form-invalid-feedback :state="validateFile(newFile)">
										Please select a file
									</b-form-invalid-feedback>
								</b-input-group>
							</td>
							<td>
								<base-button
									type="danger"
									class="vertical-dot-button"
									title="Cancel"
									v-on:click="cancelAddFile()"
								>
									<b-icon icon="x" class="font-16"></b-icon>
								</base-button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<b-row v-if="addFile">
				<b-col cols="9"></b-col>
				<b-col>
					<base-button
						type="primary"
						size="sm"
						class="w-100 mt-2"
						title="Save New File"
						v-on:click="addNewFile(carrier)"
						:disabled="!submitDisabled"
					>
						<b-icon icon="check" class="font-16"></b-icon>
						Save
					</base-button>
				</b-col>
			</b-row>
		</b-card-body>
	</div>
</template>

<script>
import otaDashboardService from "@/common/api-services/ota-dashboard-service";
import initService from "@/common/api-services/init-service";
import Toast from "../../../Components/Toast.vue";
import Swal from "sweetalert2";

export default {
	name: "CarrierFiles",
	props: {
    active_carrier: {
      type: String,
      required: true,
    },
		carrier: {
			type: Object,
			required: true,
		},
		efOptions: {
			type: Array,
			required: true,
		},
		fileTypes: {
			type: Object,
			required: true,
		},
	},
  watch: {
    active_carrier() {
      if (this.active_carrier !== this.carrier.name) return;

      this.files = [];
      this.fileErrors = [];
      this.updateFiles();
      // if (this.files.length > 0) {
      //   this.runFilesAudit()
      // }
    }
  },
	mounted() {
		// console.log(this.carrier);

		this.getFiles();

		this.isPortalAdmin = initService.getPortalAdminRole();
	},
	computed: {
		submitDisabled() {
			return this.fileNameState(this.newFile.display_name) && this.efState(this.newFile.type) && this.dataState;
		},

		dataState() {
			return this.newFile.data.length > 0 ? true : false;
		},
	},
	data() {
		return {
			isPortalAdmin: false,
			llcDataClick: true,
			isAdministrator: true,
			files: [],
			addFile: false,
			newFile: {
				display_name: "",
				type: "",
				default: false,
				add: 1,
				changed: 0,
				data: "",
				efDisabled: false,
			},
			imageData: null,
			oldFileValues: {},
			updateFile: [],
			updateData: [],
      fileErrors: [],
      isLoading: false,
      errorStatus: false,
		};
	},
	methods: {
		getFiles() {
      this.isLoading = true;
      if (this.active_carrier !== this.carrier.name) return;
			this.files = [];
			this.carrier.files.map(file => {
				// console.log({...file})
				file.id = file.id.toString();
				if (typeof file.data === "boolean" || file.data === undefined) {
					file.data = "";
				}

				if (!file.hasOwnProperty("default")) {
					file.default = false;
				}

				if (file.disabled === undefined) {
					file.disabled = 0;
				} else {
					file.disabled = parseInt(file.disabled);
				}

				let previous = {...file}; // structuredClone(file)
				file.previous = previous;
				this.files.push(structuredClone(file));
			});
      this.runFilesAudit()
		},

		updateFiles() {
      this.isLoading = true;
			this.files = [];
			otaDashboardService.getCarrierFiles({carrier: this.carrier.name}).then(res => {
				if (res && res.data.status) {
					// console.log(res.data.result)
					for (const key in res.data.result) {
						res.data.result[key].map(file => {
							// console.log(file)
							file.id = file.id.toString();
							if (typeof file.data === "boolean" || file.data === undefined) {
								file.data = "";
							}

							if (!file.hasOwnProperty("default")) {
								file.default = false;
							}

							file.efDisabled = true;
							file.type = key;

							if (file.disabled === undefined) {
								file.disabled = 0;
							} else {
								file.disabled = parseInt(file.disabled);
							}

							let previous = {...file}; // structuredClone(file)
							file.previous = previous;
							this.files.push(structuredClone(file));
						});
					}
          this.runFilesAudit()
				} else {
          this.isLoading = false;
          this.errorStatus = true;
					this.$toast.error({
						component: Toast,
						props: {
							subtitle: "ERROR:",
							description: res.data.error_string,
						},
					});
				}
			})
      .catch(err => {
        console.error(err);
        this.isLoading = false;
      });
		},

    async runFilesAudit() {
      this.fileErrors = [];
      await new Promise((resolve, reject) => {
        this.files.map(async (file, i) => {
          let valid = false
          // console.log(file)

          // only audit stored files
          if (file.data !== "") return

          let payload = {
            carrier: this.carrier.name,
            name: file.name,
            type: file.type,
          }
          await otaDashboardService
            .getCarrierFileInfo(payload)
            .then(res => {
              if (res && res.data.status) {
                let data = res.data.result;
                if (data.size > 2) {
                  // console.log("File is valid")
                  valid = true
                }
              }
            })
            .catch(err => {
              console.error(err);
            });

            if (!valid) {
              this.fileErrors.push(i)
            }
        })
        resolve()
      }).finally(() => {
        this.isLoading = false;
      }) 
    },

		fileNameState(name, index) {
			if (index !== undefined) {
				if (name === this.files[index].display_name) {
					return null;
				}
				if (name === this.oldFileValues) {
					return null;
				}
			}
			if (name !== undefined && name.match("^[a-zA-Z0-9]")) {
				return true;
			} else {
				return false;
			}
		},

		validateFile(file) {
			// console.log(file);
			if (file.data && file.data.length > 0) {
				return true;
			} else {
				return false;
			}
		},

		addNewFile(carrier) {
			let payload = {
				carrier: carrier.name,
				display_name: this.newFile.display_name,
				type: this.newFile.type,
				default: this.newFile.default,
				data: this.newFile.data,
			};
			otaDashboardService
				.addCarrierFile(payload)
				.then(res => {
					if (res && res.data.status) {
						this.$toast.success({
							component: Toast,
							props: {
								subtitle: "PASS:",
								description: `File ${payload.display_name} was added successfully.`,
							},
						});
						this.updateFiles(); // this.$root.$emit("getCarrierList_API");
						this.cancelAddFile();
					} else {
						this.$toast.error({
							component: Toast,
							props: {
								subtitle: "ERROR:",
								description: res.data.error_string,
							},
						});
					}
				})
				.catch(err => {
					this.$toast.error({
						component: Toast,
						props: {
							subtitle: "ERROR:",
							description: err.message,
						},
					});
				});
		},

		cancelAddFile() {
			this.addFile = false;
			this.newFile = {
				display_name: "",
				type: "",
				default: false,
				changed: 0,
				data: "",
				efDisabled: false,
			};
		},

		efState(type) {
			if (type !== "") {
				return true;
			} else {
				return false;
			}
		},

		handleEfChange(file) {
			// console.log(file)
			// console.log(this.carrierFiles)
			// console.log(this.fileTypes[file.type])
			file.data = "";
		},

		setRowEdit(file, index) {
			// this.$root.$emit("setConfirmMessage", true)
			// this.oldFileValues = structuredClone(file);
			// console.log(file)
			this.updateFile.push(index);
		},

		saveUpdatedFile(carrier, file, index) {
			// console.log("saveUpdatedFile fired");
			let payload = {
				id: parseInt(file.id),
				carrier: carrier.name,
				display_name: file.display_name,
				type: file.type,
				default: file.default,
				data: file.data,
			};
			otaDashboardService
				.editCarrierFile(payload)
				.then(res => {
					if (res && res.data.status) {
						this.$toast.success({
							component: Toast,
							props: {
								subtitle: "PASS:",
								description: `File ${payload.display_name} was updated successfully.`,
							},
						});
						this.updateFiles(); // this.$root.$emit("getCarrierList_API");
						this.updateFile = this.updateFile.filter(item => item !== index);
					} else {
						this.$toast.error({
							component: Toast,
							props: {
								subtitle: "ERROR:",
								description: res.data.error_string,
							},
						});
					}
				})
				.catch(err => {
					this.$toast.error({
						component: Toast,
						props: {
							subtitle: "ERROR:",
							description: err.message,
						},
					});
				});
		},

		deleteFile(file) {
			let payload = {
				carrier: this.carrier.name,
				id: file.id,
				name: file.display_name,
				default: file.default,
				type: file.type,
			};
			Swal.fire({
				title: `Delete file`,
				text: `Are you sure you want to delete file ${file.display_name}?`,
				showCloseButton: true,
				showCancelButton: true,
				confirmButtonText: "DELETE",
				cancelButtonText: "Cancel",
				customClass: {
					cancelButton: 'order-1 mr-3',
					confirmButton: 'btn btn-danger order-2',
				},
			}).then(result => {
				if (result.isConfirmed) {
					otaDashboardService
						.removeCarrierFile(payload)
						.then(res => {
							if (res && res.data.status) {
								this.$toast.success({
									component: Toast,
									props: {
										subtitle: "PASS:",
										description: `File ${file.display_name} was deleted successfully.`,
									},
								});
								this.updateFiles(); // this.$root.$emit("getCarrierList_API");
							} else {
								this.$toast.error({
									component: Toast,
									props: {
										subtitle: "ERROR:",
										description: res.data.error_string,
									},
								});
							}
						})
						.catch(err => {
							this.$toast.error({
								component: Toast,
								props: {
									subtitle: "ERROR:",
									description: err.message,
								},
							});
						});
				}
			});
		},

		cancelFileChange(carrier, file, fileIndex) {
			this.updateData = this.updateData.filter(item => item !== fileIndex);
			this.updateFile = this.updateFile.filter(item => item !== fileIndex);
			file.data = file.previous.data;
			file.changed = "0";
			file.default = file.previous.default;
			file.display_name = file.previous.display_name;
			// this.$root.$emit("setConfirmMessage", false)
		},

		getFile(e, file) {
			const files = document.getElementById(e.target.id).files;
			// console.log(files[0]);
			if (files.length > 0) {
				this.getBase64(files[0], file);
			}
		},

		getBase64(data, file) {
			// console.log("getBase64 fired");
			const reader = new FileReader();
			reader.readAsDataURL(data);
			reader.onload = () => {
				const inputData = reader.result;
				const replaced = inputData.split(",")[0];
				const data = inputData.replace(replaced + ",", "");
				if (data) {
					this.imageData = data;
					file.data = data;
					file.changed = "0";
					file.add = "1";
				}
			};
			reader.onerror = e => e;
		},

		getInfo_API(data) {
			otaDashboardService
				.getCarrierFileInfo(data)
				.then(res => {
					if (res && res.data.status) {
						let data = res.data.result;
						if (data.size === 1) {
							data.size = `${data.size} Byte`;
						} else {
							data.size = `${data.size} Bytes`;
						}
						this.$root.$emit("DisplayFileInfo", data);
						// this.$bvModal.show("testInfoModal");
						// this.disable = false;
						// this.showModal = true;
						// this.info = true;
						// this.fileInfo = res.data.result;
					} else {
						this.$toast.error({
							component: Toast,
							props: {
								subtitle: "ERROR:",
								description: res.data.error_string,
							},
						});
					}
				})
				.catch(err => {
					this.$toast.error({
						component: Toast,
						props: {
							subtitle: "ERROR:",
							description: err.message,
						},
					});
				});
		},

		downloadFile_API(data) {
			// console.log(data);
			otaDashboardService.downloadCarrierFile(data)
		},

		disableFile_API(data) {
			// console.log("disableFile_API fired");
			// console.log(data);

			otaDashboardService
				.disableCarrierFile(data)
				.then(res => {
					// console.log(res);
					if (!res.data.status) {
						this.$toast.error({
							component: Toast,
							props: {
								subtitle: "ERROR:",
								description: res.data.error_string,
							},
						});
					} else {
						this.$toast.success({
							component: Toast,
							props: {
								subtitle: "PASS:",
								description: `File ${data.name} was ${
									data.disable === 1 ? "disabled" : "enabled"
								} successfully.`,
							},
						});
						this.updateFiles(); // this.$root.$emit("getCarrierList_API");
					}
				})
				.catch(err => {
					// console.error(err);
					this.$toast.error({
						component: Toast,
						props: {
							subtitle: "ERROR:",
							description: err.message,
						},
					});
				});
		},

		showDisableFileModal(payload) {
			// console.log(payload);
			if (payload.disable === 1) {
				Swal.fire({
					title: `Disable file`,
					text: `This will disable the file and make it completely inaccessible for new provisions. Are you sure you want to continue?`,
					showCloseButton: true,
					showCancelButton: true,
					confirmButtonText: "Ok",
					cancelButtonText: "Cancel",
					customClass: {
						cancelButton: 'order-1 mr-3',
						confirmButton: 'btn btn-danger order-2',
					},
				}).then(result => {
					if (result.isConfirmed) {
						this.disableFile_API(payload);
					}
				});
			} else {
				this.disableFile_API(payload);
			}
		},
	},
};
</script>
